import React from "react";
import { GenreCard } from "@/layouts/styles/ssr.style";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { definitions } from "@/services/metruyenvl";

function CarouselArtist({ book }: { book?: definitions["do.BookDO"] }) {
    const router = useRouter();
    return (
        <div className="cursor-pointer">
            <Image
                onClick={() => {
                    router.push(`/truyen/${book?.slug}`);
                }}
                src={book?.thumbnail ?? "https://static.cdnno.com/poster/tu-phan-tich-thai-duong-bat-dau/150.jpg?1671933814"}
                alt=""
                height={200}
                width={150}
                className="m-auto"
            />
            <div
                className="mt-4 line-clamp-1 text-lg font-semibold"
                onClick={() => {
                    router.push(`/truyen/${book?.slug}`);
                }}
            >
                {book?.name ?? "Từ Phân Tích Thái Dương Bắt Đầu"}
            </div>
            <div
                className="mt-2 line-clamp-3 text-sm text-gray-500"
                onClick={() => {
                    router.push(`/truyen/${book?.slug}`);
                }}
            >
                {book?.description ?? "Ngươi phân tích thái dương, thu được một viên tàn ấn. Ngươi ngày qua ngày, năm qua năm phân tích,..."}
            </div>
            <div
                className="p-1 m-auto mt-2 border border-solid border-amber-400 text-amber-400 text-xs font-semibold w-fit"
                onClick={() => {
                    if (book?.tags !== undefined) {
                        router.push(`/the-loai/${book?.tags[0].slug}/${book?.tags[0].id}`);
                    }
                }}
            >
                {book?.tags !== undefined ? book?.tags[0].name : "Khác"}
            </div>
        </div>
    );
}

export default CarouselArtist;
